import { ReactNode } from 'react'
import classes from './ChatWidget.module.scss'

/** Kart gövdesindeki tek bir etiket/değer satırı. `wide` → satır tüm genişliği kaplar. */
export interface ResultCardItem {
  label: string
  value: ReactNode
  wide?: boolean
}

interface Props {
  /** Başlığın üstündeki küçük etiket (ör. "Seri no SJ0VQFM764V"). */
  eyebrow?: string
  title: ReactNode
  /** Başlığın altındaki ikincil satır (ör. ürün kodu). */
  subtitle?: string
  /** Sağ üstteki rozet; boşsa rozet render edilmez. */
  badge?: string
  titleId?: string
  items: ResultCardItem[]
  /** Izgaranın altındaki eylem alanı (ör. Yurtiçi takip butonu); boşsa render edilmez. */
  footer?: ReactNode
}

/**
 * Sorgu sonucu kartının ortak iskeleti: başlık şeridi + iki kolonlu etiket/değer ızgarası.
 * Veri tipi bilmez — garanti / kargo / seri no kartları bu bileşeni besleyerek kurulur, böylece
 * modal ve sohbet balonu aynı görünümü paylaşır. Dar panelde ızgara tek kolona düşer
 * (`.panelCompact .modalDetailGrid`).
 */
export default function ResultCard({ eyebrow, title, subtitle, badge, titleId, items, footer }: Props) {
  return (
    <section className={classes.modalResultCard} aria-labelledby={titleId}>
      <div className={classes.modalResultHeader}>
        <div>
          {eyebrow && <span className={classes.modalEyebrow}>{eyebrow}</span>}
          <h3 id={titleId}>{title}</h3>
          {subtitle && <span className={classes.modalProductCode}>{subtitle}</span>}
        </div>
        {badge && <span className={classes.modalStatusBadge}>{badge}</span>}
      </div>

      <dl className={classes.modalDetailGrid}>
        {items.map(item => (
          <div key={item.label} className={item.wide ? classes.modalDetailWide : undefined}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>

      {footer && <div className={classes.modalResultFooter}>{footer}</div>}
    </section>
  )
}
